import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AnchorLink from '../../../../components/AnchorLink';
import s from './ArticleHeroImageSource.module.scss';
import { trackEvent } from '../../../../utils/analytics';
import { HOME_URL } from '../../../../constants/routes';

const propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  theme: PropTypes.string,
  pageName: PropTypes.string,
};

const defaultProps = {
  theme: 'news',
  url: HOME_URL,
  pageName: '',
};

const ArticleHeroImageSource = ({ description, title, url, theme, pageName }) => (
  <div className={cx(s.heroImageSource, s[theme])}>
    <div className={s.sourceDetails}>
      <div>{description}</div>
      <AnchorLink
        href={url}
        title={title}
        onClick={() => {
          trackEvent('Link Clicked', {
            link_name: title,
            link_url: url,
            location: pageName,
          });
        }}
        target="_self"
        rel="noopener noreferrer"
      >
        {title}
      </AnchorLink>
    </div>
  </div>
);

ArticleHeroImageSource.propTypes = propTypes;
ArticleHeroImageSource.defaultProps = defaultProps;
export default ArticleHeroImageSource;
